interface UkTouhouEventBanner {
  imageUrl: string;
  creditName?: string;
  creditUrl?: string;
}

export interface UkTouhouEventRaw {
  name: string;
  description: string;
  location: string;
  begin: string;
  end: string;
  website?: string;
  banner?: UkTouhouEventBanner | string;
}

export class UkTouhouEvent {
  name: string;
  description: string;
  location: string;
  begin: Date;
  end: Date;
  website: string;
  banner: Required<UkTouhouEventBanner>;

  constructor(raw: UkTouhouEventRaw) {
    this.name = raw.name;
    this.description = raw.description;
    this.location = raw.location;
    this.begin = new Date(raw.begin);
    this.end = new Date(raw.end);
    this.website = raw.website || '';

    this.banner = typeof raw.banner === 'string' ?
      { imageUrl: raw.banner, creditName: '', creditUrl: ''} :
      (raw.banner ? {
        imageUrl: raw.banner.imageUrl,
        creditName: raw.banner.creditName || '',
        creditUrl: raw.banner.creditUrl || '',
      } : null);
  }

  get id(): string {
    return `${this.begin.getFullYear()}-${addZero(this.begin.getMonth() + 1)}-${addZero(this.begin.getDate())}-` +
      this.name
        .toLowerCase()
        .replace(/ /g, '-')
        .replace(/[^a-z0-9-_]/g, '')
        .replace(/-+/g, '-');
  }

  get isPast(): boolean {
    return this.end < Date.now();
  }

  get isUpcoming(): boolean {
    return this.begin > Date.now();
  }

  get isInProgress(): boolean {
    return !this.isPast && !this.isUpcoming;
  }

  get isMultiDay(): boolean {
    return this.begin.getFullYear() !== this.end.getFullYear() ||
      this.begin.getMonth() !== this.end.getMonth() ||
      this.begin.getDate() !== this.end.getDate();
  }

  get dateToString(): string {
    const weekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const currentYear = (new Date()).getFullYear();
    const timeStr = (d: Date) => `${addZero(d.getHours())}:${addZero(d.getMinutes())}`;
    const dateStr = (d: Date) => {
      const year = d.getFullYear() === currentYear ? '' : ` ${d.getFullYear()}`;
      return `${weekdays[d.getDay()]} ${d.getDate()} ${months[d.getMonth()]}${year}, ${timeStr(d)}`;
    };

    return `${dateStr(this.begin)} - ${this.isMultiDay ? dateStr(this.end) : timeStr(this.end)}`;
  }

  get locationOneLine(): string {
    return this.location.replace(/\n/g, '; ');
  }
}

// Helper function
const addZero = (val: (number | string)) => ('0' + val).slice(-2);
